export default "__VITE_ASSET__CnTJGdVa__"